import DoAPICall from './DoAPICall'

//Create Customer Field
    export async function createCustomerField(userToken, customerField){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'customerfields',
                payLoad:{
                    client_id:customerField.client_id,
                    name:customerField.name,
                    order:customerField.order,
                    prompt:customerField.prompt,
                    type:customerField.type,
                    placeHolder:customerField.placeHolder
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All Customer Field
    export async function getCustomerFields(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'customerfields',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Customer Fields of Client
    export async function getCustomerFieldsOfClient(userToken,client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'customerfieldsofclient/'+client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Customer Field
    export async function getCustomerField(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'customerfields/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Customer Field
    export async function updateCustomerField(userToken, customerField){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'customerfields/'+customerField.id,
            payLoad:{
                client_id:customerField.client_id,
                name:customerField.name,
                order:customerField.order,
                prompt:customerField.prompt,
                type:customerField.type,
                placeHolder:customerField.placeHolder
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Customer Field
    export async function deleteCustomerField(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'customerfields/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }




